import React from "react";
import "../../../../css/Turismo/turismo.css";

const imagenes = [
  require("../../../img/maraton/maraton-1.jpg"),
  require("../../../img/maraton/maraton-2.jpg"),
  require("../../../img/maraton/maraton-3.jpg"),
  require("../../../img/maraton/maraton-4.jpg"),
  require("../../../img/maraton/maraton-5.jpg"),
  require("../../../img/maraton/maraton-6.jpg"),
  require("../../../img/maraton/maraton-8.jpg"),
  require("../../../img/maraton/maraton-9.jpg"),
  require("../../../img/maraton/maraton-10.jpg"),
  require("../../../img/maraton/maraton-11.jpg"),
];

const Maraton = () => (
  <div>
    <div
      className="maraton text-center"
      style={{
        backgroundImage: `url(${require("../../../img/maraton-2.jpeg")})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundPositionY: "-150px",
        paddingTop: 100,
        paddingBottom: 100,
        backgroundAttachment: "fixed",
        position: "relative",
        height: 450,
        marginBottom: 30,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1,
        }}
      />
    </div>
    <div className="container">
      <div className="info-maraton">
        <h1 className="text-center">
          <strong>MARATÓN HÉROES DE MALVINAS</strong>
        </h1>
        <p>
          Este evento deportivo se lleva cabo todos los 2 de abril de cada año,
          el mismo es en conmemoración por el “Día del Veterano y los Caídos en
          la Guerra de Malvinas”, su escenario principal es en la inmediaciones
          o cercanías del Predio del Museo Nacional de Malvinas, y en su última
          edición se tuvo la participación de aprox. 600 a 700 corredores.
        </p>
        <p>
          Es una Maratón de gran amplitud en donde se entregan diferentes
          premios económicos, se puede participar de diferentes categorías que
          van desde la niñez hasta el adulto mayor, y se destacan la presencia
          de corredores olímpicos y Veteranos de Guerra.
        </p>
        <br />
        <div className="row">
          <section className="col-12">
            <div
              id="carouselMaraton"
              className="carousel slide"
              data-bs-ride="carousel"
            >
              <div className="carousel-inner">
                {imagenes.map((img, idx) => (
                  <div
                    className={`carousel-item${idx === 0 ? " active" : ""}`}
                    key={idx}
                  >
                    <img
                      src={img}
                      alt={`maraton-${idx + 1}`}
                      style={{
                        width: "100%",
                        height: "auto",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                ))}
              </div>
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselMaraton"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Anterior</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselMaraton"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Siguiente</span>
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
);

export default Maraton;
